import { useAdmin } from "../../../context/admin";
import List from "./List";
import Create from "./Create";
import Subzones from "../Subzones";

export default function Zones() {
    const { subzonesZone } = useAdmin()
    if (subzonesZone) return <Subzones/>
    return (
        <>
        <Create/>
        <List/>
        </>
    )
}
